/** Status da tarefa em segundo plano; espelha `TaskStatusType` do backend. */
export enum TaskStatusType {
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
}
